export class Permissions {
    public static readonly ADMIN: string = 'role:admin';
    public static readonly SYSTEM: string = 'role:system';

    public static readonly VIEW_ENQUIRIES: string = 'enquiries:view';
    public static readonly CREATE_ENQUIRIES: string = 'enquiries:create';

    public static readonly VIEW_QUOTES: string = 'quotes:view';
    public static readonly CREATE_QUOTES: string = 'quotes:create';

    public static readonly VIEW_ORDERS: string = 'orders:view';
    public static readonly CREATE_ORDERS: string = 'orders:create';

    public static readonly VIEW_APPROVALS: string = 'approvals:view';
    public static readonly APPROVE_UP_TO_1K: string = 'approvals:approve:1k';
    public static readonly APPROVE_FROM_1K_TO_5K: string = 'approvals:approve:5k';
    public static readonly APPROVE_FROM_5K_TO_10K: string = 'approvals:approve:10k';
    public static readonly APPROVE_ALL: string = 'approvals:approve:unlimited';
}
